import { useEffect, useRef } from "react";
import { Field } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import { StepLayout } from "../components/StepLayout";
import { focusWithoutPan } from "../focusWithoutPan";

export interface AgeStepProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  showError: boolean;
}

export function AgeStep({ value, onChange, onSubmit, showError }: AgeStepProps) {
  const ref = useRef<HTMLInputElement>(null);
  const { t } = useTranslation("client");

  // The keyboard should already be up when the step lands — this is the only
  // step where the answer is typed and short enough that reaching for the
  // field first is pure friction. preventScroll matches focusWithoutPan
  // below: skips the same WebKit "will this be visible" check a plain
  // focus() would trigger.
  useEffect(() => {
    ref.current?.focus({ preventScroll: true });
  }, []);

  return (
    <StepLayout title={t("onboarding.age.title", "Kuinka vanha olet?")}>
      <Field
        ref={ref}
        label={t("onboarding.age.label", "Ikä")}
        // type="text" with inputmode="numeric" rather than type="number":
        // it gets the numeric keypad without the spinner, and without
        // Safari's silent value-drop on a partially typed entry.
        type="text"
        inputMode="numeric"
        maxLength={3}
        autoComplete="off"
        placeholder={t("onboarding.age.placeholder", "esim. 34")}
        value={value}
        errorText={showError ? t("onboarding.age.invalid", "Anna ikä välillä 18–120.") : undefined}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, ""))}
        onMouseDown={focusWithoutPan}
        onKeyDown={(e) => {
          if (e.key === "Enter") onSubmit();
        }}
      />
    </StepLayout>
  );
}
